import type { Account, AccountLifecycle, AccountUser, DataResponse } from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

/**
 * The caller's own account (MILO-178): the member list and the terms
 * acceptance. Billing and the API settings have services of their own.
 */
class AccountService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    /** Everyone who holds a login on the account, the owner included, oldest first. */
    users(): Promise<AxiosResponse<DataResponse<AccountUser[]>>> {
        return this.apiService.get('/api/account/users');
    }

    /** Owner only, session only: puts the current terms version on file (MILO-526). */
    acceptTerms(): Promise<AxiosResponse<DataResponse<Account>>> {
        return this.apiService.post('/api/account/terms-acceptance');
    }

    /**
     * Owner only: lengthen the transition period once, by a number of days of
     * the customer's choosing (MILO-146, terms 12.2). 422 outside that period
     * or when already extended.
     */
    extendTransition(days: number): Promise<AxiosResponse<DataResponse<{ lifecycle: AccountLifecycle }>>> {
        return this.apiService.post('/api/billing/transition/extend', { days });
    }
}

export default AccountService;
